import { datadogLogs } from '@datadog/browser-logs';
import { config } from '../../utils';

const CLIENT_TOKEN = 'pub146162de38f2cfb118ed58d68360844c';
const SERVICE_NAME = 'javascript';
const SITE_NAME = 'datadoghq.com';
const env = config?.environment;

datadogLogs.init({
  clientToken: CLIENT_TOKEN,
  sessionPersistence: 'local-storage',
  site: SITE_NAME,
  forwardErrorsToLogs: true,
  service: SERVICE_NAME,
  env: env,
  version: config?.source_map_version.toString()
});

const logger = datadogLogs.logger;
window.onerror = function customErrorHandler (errorMessage, url, lineNumber, columnNumber, errorObject) 
{
    logger.error(errorMessage, { url, lineNumber, columnNumber, errorObject });
    
    if(env !== 'production') {
      console.error([errorMessage, url, lineNumber, columnNumber, errorObject]);
      alert(errorMessage);
    }
};

export { logger }